import request from '@/utils/request'

/**
 * 查询电站基本数据
 * @param {String|Number} stationId 电站ID
 */
export function getStationBaseData(stationId) {
  return request({
    url: `/dashboard/v3/stationDetails/baseData/${stationId}`,
    method: 'get'
  })
}

/**
 * 根据电站ID获取elink和eblock结构数据
 * @param {*} stationId
 * @returns
 */
export function getElinkList(stationId) {
  const id = Number(stationId)
  // 防御：stationId 为 undefined/''/非法值时 Number() 会得到 NaN，
  // 直接拼进 URL 会产生 /eLinkList/NaN 这类无效请求
  if (!Number.isFinite(id) || id <= 0) {
    return Promise.reject(new Error(`getElinkList: 无效的 stationId "${stationId}"`))
  }
  return request({
    url: `/device/elink/eLinkList/${id}`,
    method: 'get'
  })
}

/**
 * 数据分析/SOC-功率跟踪分析
 * @param {Object} params
 * @param {String} params.startTime 开始时间
 * @param {String} params.endTime 结束时间
 * @param {String|Number} params.stationId 电站ID
 * @param {Boolean} params.allElink 是否查询所有Elink
 * @param {Boolean} params.allEblock 是否查询所有Eblock
 * @param {Array} params.elinkIDs Elink ID数组
 * @param {Array} params.eblockIDs Eblock ID数组
 * @returns
 */
export function fetchPowerTrackingData({ startTime, endTime, stationId, allElink, allEblock, elinkIDs, eblockIDs }) {
  return request({
    url: `/dashboard/dataAnalysis/powerTracking/querySocAndPower`,
    method: 'post',
    data: {
      startTime,
      endTime,
      stationId: String(stationId),
      allElink: Boolean(allElink),
      allEblock: Boolean(allEblock),
      elinkIDs: elinkIDs || [],
      eblockIDs: eblockIDs || []
    }
  })
}

/**
 * 导出电站数据
 * @param {Object} data
 * @returns
 */
export function exportStationData(data) {
  return request({
    url: '/supervisor/data/download/export2',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}





/**
 * 获取电站策略 接口：/dashboard/v3/station/strategy/{stationId}
 * @param {String|Number} stationId 电站ID
 * @returns
 */
export function getStationStrategy(stationId) {
  return request({
    url: `/dashboard/v3/station/strategy/${stationId}`,
    method: 'get'
  })
}
